/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable, OnDestroy } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import {
    selectClusterNameToAddressMap,
    selectClusterNameToRackId
} from '../../configuration/+state/configuration.selectors';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import path from 'node:path';

@Injectable({
    providedIn: 'root'
})
export class ClusterUrlProviderService implements OnDestroy {
    public _clusterMap: { [clusterName: string]: string } = {};
    public _clusterToRackIdMap: { [clusterName: string]: string } = {};
    private unsubscribe$ = new Subject<void>();

    constructor(
        private env: EnvironmentService,
        private store: Store,
        protected http: HttpClient
    ) {
        this.store
            .select(selectClusterNameToAddressMap)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((clusterMap) => {
                this._clusterMap = clusterMap;
            });
        this.store
            .select(selectClusterNameToRackId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((clusterToRackIdMap) => {
                this._clusterToRackIdMap = clusterToRackIdMap;
            });
    }

    get clusterMap() {
        return this._clusterMap;
    }

    get clusterToRackIdMap() {
        return this._clusterToRackIdMap;
    }

    public getClusterSpecificUrl(clusterName: string, path?: string): string {
        return `${this.clusterMap[clusterName]}${path || ''}`;
    }

    public getClusterRackId(clusterName: string): string {
        return this.clusterToRackIdMap[clusterName];
    }

    //@deprecated
    public getCtcUrl(): string {
        return this.env.environment.CTC_URL ? this.env.environment.CTC_URL : '';
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
